export const parseTerminals = (terminals) => {
  if (!terminals) return [];
  if (Array.isArray(terminals)) {
    return terminals.map((terminal) => parseTerminal(terminal));
  }
  // If it's an object, convert to array
  return Object.values(terminals).map((terminal) => parseTerminal(terminal));
};

const parseHistory = (history) => {
  if (!history) return [];
  return Array.isArray(history) ? history : [];
};

export const parseTerminal = (terminal) => {
  if (!terminal) return {};
  const history = terminal?.history;
  return {
    activeInput: terminal?.activeInput,
    minified: terminal?.minified,
    executing: terminal?.executing,
    uuid: terminal?.uuid,
    visible: terminal?.visible,
    active: terminal?.active,
    command: terminal?.command,
    caretPosition: terminal?.caretPosition,
    history: parseHistory(history),
    historyIndex: terminal?.historyIndex,
  };
};

export const moveCursorToEnd = (el) => {
  if (typeof el.selectionStart == "number") {
    el.selectionStart = el.selectionEnd = el.value.length;
  } else if (typeof el.createTextRange != "undefined") {
    el.focus();
    var range = el.createTextRange();
    range.collapse(false);
    range.select();
  }
};

export const canceledCommandProperties = () => {
  return {
    canceled: true,
    suffix: "^C",
  };
};
